import React from 'react';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0', gold: '#C9A84C', gray: '#888', surface: '#111111' };

// TODO(M1): Wire profile section to GET/PUT /api/auth/me
// TODO(M2): Wire notification preferences to user settings API
// TODO(M3): Implement delete account flow with confirmation and ownership transfer

function SettingsSection({ title, description, children }) {
  return (
    <div style={{
      borderBottom: `1px solid rgba(255,255,255,0.07)`,
      paddingBottom: '2.5rem',
      marginBottom: '2.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.25rem',
    }}>
      <div>
        <h2 style={{
          fontSize: '0.8rem',
          fontWeight: 800,
          letterSpacing: '0.15em',
          color: COLORS.white,
          margin: '0 0 0.4rem',
        }}>
          {title}
        </h2>
        {description && (
          <p style={{
            fontSize: '0.8rem',
            color: COLORS.gray,
            margin: 0,
            lineHeight: 1.6,
          }}>
            {description}
          </p>
        )}
      </div>
      {children}
    </div>
  );
}

function ComingSoonBox({ note }) {
  return (
    <div style={{
      padding: '1.5rem',
      border: `1px dashed rgba(255,255,255,0.12)`,
      backgroundColor: 'rgba(255,255,255,0.015)',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    }}>
      <p style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.35)', margin: 0, letterSpacing: '0.08em' }}>
        Coming soon
      </p>
      {note && (
        <p style={{ fontSize: '0.72rem', color: COLORS.gray, margin: 0, fontStyle: 'italic', fontFamily: 'Georgia, serif' }}>
          {note}
        </p>
      )}
    </div>
  );
}

export default function Settings() {
  return (
    <div style={{ maxWidth: '640px', display: 'flex', flexDirection: 'column', gap: '0' }}>
      {/* Header */}
      <div style={{ marginBottom: '3rem' }}>
        <p style={{
          fontSize: '0.65rem',
          letterSpacing: '0.25em',
          color: COLORS.gold,
          margin: '0 0 0.5rem',
          fontWeight: 600,
        }}>
          ACCOUNT
        </p>
        <h1 style={{
          fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
          fontWeight: 900,
          letterSpacing: '-0.01em',
          color: COLORS.white,
          margin: 0,
        }}>
          ACCOUNT SETTINGS
        </h1>
      </div>

      {/* Profile section */}
      <SettingsSection
        title="PROFILE"
        description="Your name and email address. Your email is your login and how we contact you about your pieces."
      >
        {/* TODO(M1): Pre-fill from session, wire to PUT /api/auth/me */}
        <ComingSoonBox note="Profile editing — name and email update — coming in M1 with full auth implementation." />
      </SettingsSection>

      {/* Password section */}
      <SettingsSection
        title="SECURITY"
        description="Change your password. We recommend using a unique password and enabling two-factor authentication when available."
      >
        {/* TODO(M1): Wire to POST /api/auth/change-password */}
        <ComingSoonBox note="Password change flow — including email verification step — coming in M1." />
      </SettingsSection>

      {/* Notifications section */}
      <SettingsSection
        title="NOTIFICATIONS"
        description="Control when QRQY contacts you. We'll always send transactional emails (order confirmation, activation)."
      >
        {/* TODO(M2): Notification preferences toggles */}
        <ComingSoonBox note="Scan milestone alerts, weekly digest — notification preferences coming in M2." />
      </SettingsSection>

      {/* Danger zone */}
      <SettingsSection
        title="DANGER ZONE"
        description="Permanent account actions. Deleting your account will deactivate all your QR codes — scanners will see the QRQY activation page."
      >
        {/* TODO(M3): Delete account — requires ownership handling (transfer or deactivate), email confirmation */}
        <div style={{
          padding: '1.5rem',
          border: `1px solid rgba(224,92,92,0.2)`,
          backgroundColor: 'rgba(224,92,92,0.04)',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
        }}>
          <p style={{ fontSize: '0.75rem', color: 'rgba(224,92,92,0.7)', margin: 0, letterSpacing: '0.08em' }}>
            DELETE ACCOUNT
          </p>
          <p style={{ fontSize: '0.78rem', color: COLORS.gray, margin: 0, lineHeight: 1.6 }}>
            This action is permanent and cannot be undone. All QR codes associated with your account
            will be deactivated. This feature will be available in M3 after the ownership
            transfer/deactivation flow is fully designed.
          </p>
          <button
            disabled
            style={{
              alignSelf: 'flex-start',
              padding: '0.65rem 1.5rem',
              backgroundColor: 'transparent',
              border: `1px solid rgba(224,92,92,0.3)`,
              color: 'rgba(224,92,92,0.4)',
              fontSize: '0.7rem',
              fontWeight: 700,
              letterSpacing: '0.15em',
              cursor: 'not-allowed',
            }}
          >
            DELETE MY ACCOUNT
          </button>
          {/* TODO(M3): Implement delete account with:
            1. Confirmation dialog ("type CONFIRM to proceed")
            2. Email confirmation link
            3. Deactivate all qr_codes WHERE owner_id = userId
            4. Mark user record as deleted (soft delete — retain for audit)
            5. Invalidate session
          */}
        </div>
      </SettingsSection>
    </div>
  );
}
